<div class="modal-backdrop">
  <div class="modal-box scrollable">
    <form #categoryForm="ngForm">
      <h3>{{ categoryData?.id ? 'Modifica' : 'Nuova' }} Categoria</h3>

      <label>Nome *</label>
      <input [(ngModel)]="categoryData.name" name="name" required />

      <label>Codice *</label>
      <input [(ngModel)]="categoryData.code" name="code" required />

      <label>Incremento Festivo (%)</label>
      <input type="number" [(ngModel)]="categoryData.percIncrementoFestivoRif" name="percIncrementoFestivoRif" onwheel="this.blur()" />

      <label>Incremento Notturno (%)</label>
      <input type="number" [(ngModel)]="categoryData.percIncrementoNotturnoRif" name="percIncrementoNotturnoRif" onwheel="this.blur()" />

      <label>Incremento Trasferta (%)</label>
      <input type="number" [(ngModel)]="categoryData.percIncrementoTrasfertaRif" name="percIncrementoTrasfertaRif"
       onwheel="this.blur()" />

      <div class="checkbox-row">
        <input type="checkbox" [(ngModel)]="categoryData.isActive" id="isActive" name="isActive" />
        <label for="isActive">
          Attiva
          <mat-icon matTooltip="Se attivo: comparirà in preventivazione. Se disattivo: sarà visibile ma non cliccabile."
            fontIcon="info" style="font-size:16px; vertical-align: middle; cursor: pointer; color: #555;">
          </mat-icon>
        </label>
      </div>

      <div class="checkbox-row">
        <input type="checkbox" [(ngModel)]="categoryData.isVisible" id="isVisible" name="isVisible" />
        <label for="isVisible">
          Visibile
          <mat-icon matTooltip="Se visibile: comparirà in preventivazione. Se non visibile: non verrà mostrato."
            fontIcon="info" style="font-size:16px; vertical-align: middle; cursor: pointer; color: #555;">
          </mat-icon>
        </label>
      </div>

      <!-- Avviso -->
      <div *ngIf="categoryData.isActive && !categoryData.isVisible" class="warning-message">
        Attenzione: un elemento attivo ma non visibile non sarà comunque mostrato in preventivazione.
      </div>


      <hr class="section-divider" />

      <label>Codice Nazione</label>
      <input [(ngModel)]="categoryData.codCountry" name="codCountry" readonly />

      <label>Lingua</label>
      <input [(ngModel)]="categoryData.codLanguage" name="codLanguage" readonly />

      <label *ngIf="categoryData.createdAt">Creato il</label>
      <input *ngIf="categoryData.createdAt" [(ngModel)]="categoryData.createdAt" name="createdAt" readonly />

      <label *ngIf="categoryData.updatedAt">Ultima modifica</label>
      <input *ngIf="categoryData.updatedAt" [(ngModel)]="categoryData.updatedAt" name="updatedAt" readonly />

      <div class="modal-buttons">
        <button type="button" (click)="onSave()" [disabled]="!isFormValid() || isUnchanged()">
          Salva
        </button>
        <button type="button" (click)="onClose()">Annulla</button>
      </div>
    </form>
  </div>
</div>